import React from 'react';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';
import { SalesOrderFilters } from '../../../../app/models/SalesOrder';

type Props = {
    filter: SalesOrderFilters;
    setFilter: (filter: SalesOrderFilters) => void;
    onSearch: () => void;
};

const SalesOrderFilter = ({ filter, setFilter, onSearch }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="id">
                            ID
                        </label>
                        <input
                            title="ID"
                            type="text"
                            id="id"
                            name="id"
                            className="form-control form-control-sm"
                            value={filter.id || ''}
                            onChange={handlerInputFilter}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="society_id">
                            ID Sociedad
                        </label>
                        <input
                            title="ID Sociedad"
                            type="text"
                            id="society_id"
                            name="society_id"
                            className="form-control form-control-sm"
                            value={filter.society_id || ''}
                            onChange={handlerInputFilter}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="client_id">
                            ID Cliente
                        </label>
                        <input
                            title="ID Cliente"
                            type="text"
                            id="client_id"
                            name="client_id"
                            className="form-control form-control-sm"
                            value={filter.client_id || ''}
                            onChange={handlerInputFilter}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div style={{ marginTop: '22px' }}>
                        <ButtonSearchFilter callbackSearch={onSearch} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesOrderFilter;

